<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/view', params: {id: branch.id} }">
                                {{ branch.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Create Program
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-8">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Program
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <form v-on:submit.prevent="save">
                            <div class="row">
                                <div class="col-4 align-self-end">
                                    <div class="form-group">
                                        <label class="font-weight-medium required">Pilih Program</label>
                                        <select v-model="form.gradeID" class="form-control form-control-sm" required>
                                            <option disabled value="">Pilih Program</option>
                                            <option v-for="grade in grades" v-bind:value="grade.id" v-bind:key="grade.id">{{ grade.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-8 align-self-end">
                                    <div class="form-group">
                                        <label class="font-weight-medium required">Tipe Kelas</label>
                                        <multiselect v-model="form.programType" v-bind:options="types" v-bind:taggable="true" v-bind:allow-empty="false" tag-placeholder="" select-label="" v-on:tag="addTag" placeholder="Tipe Kelas" class="form-control form-control-sm" required>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12" v-for="(periods, patternIndex) in form.patterns">
                                    <div class="row">
                                        <div class="col">
                                            <h4 class="text-danger font-weight-bold mb-1">
                                                Pola {{ patternIndex + 1 }}
                                                <a href="#" v-if="form.patterns.length > 1" v-on:click.prevent="removePattern(patternIndex)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-4">
                                            <label class="font-weight-medium required mb-1">Hari Pola</label>
                                        </div>
                                        <div class="col-md-8 d-none d-md-block">
                                            <label class="font-weight-medium required mb-1">Sesi Pola</label>
                                        </div>
                                    </div>
                                    <div class="row" v-for="(period, index) in periods">
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 col-md-4">
                                                    <div class="form-group">
                                                        <select v-model="period.day" class="form-control form-control-sm" required>
                                                            <option disabled value="">Pilih Hari</option>
                                                            <option v-for="n in 7" v-bind:value="n">{{ $moment.weekdays(n) }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-md-8">
                                                    <div class="row">
                                                        <div class="col pr-1">
                                                            <div class="form-group">
                                                                <datetimepicker v-model="period.start" v-bind:config="datetimepickerOption" placeholder="Waktu Mulai" class="form-control-sm" required></datetimepicker>
                                                            </div>
                                                        </div>
                                                        <div class="col-auto px-1 text-center">
                                                            <i class="fa fa-minus"></i>
                                                        </div>
                                                        <div class="col px-1">
                                                            <div class="form-group">
                                                                <datetimepicker v-model="period.end" v-bind:config="datetimepickerOption" placeholder="Waktu Selesai" class="form-control-sm" required></datetimepicker>
                                                            </div>
                                                        </div>
                                                        <div class="col px-1">
                                                            <div class="form-group">
                                                                <input v-model="period.slots" type="number" class="form-control form-control-sm" placeholder="Jumlah Slot" required />
                                                            </div>
                                                        </div>
                                                        <div class="col-auto pl-1 text-center">
                                                            <a href="#" v-if="periods.length > 1" v-on:click.prevent="removeTime(patternIndex, index)">
                                                                <i class="fa fa-times text-danger"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="d-block d-md-none mt-0" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 mb-4">
                                            <button class="btn btn-link btn-sm px-0" type="button" v-on:click="addTime(patternIndex)">
                                                Tambah Hari Pola +
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 mb-4" v-for="(intensive, intensiveIndex) in form.intensiveSchedules">
                                    <div class="row">
                                        <div class="col">
                                            <h4 class="text-danger font-weight-bold mb-1">
                                                Sesi Intensif {{ intensiveIndex + 1 }}
                                                <a href="#" v-on:click.prevent="removeIntensive(intensiveIndex)">
                                                    <i class="fa fa-times text-danger"></i>
                                                </a>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5">
                                            <label class="font-weight-medium required mb-1">Nama Sesi</label>
                                            <div class="form-group">
                                                <input v-model="form.intensiveSchedules[intensiveIndex]" class="form-control form-control-sm" placeholder="Nama Kelas" required />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-right mb-4">
                                    <button class="btn btn-outline-danger px-5 btn-sm mb-2" type="button" v-on:click="addIntensive">
                                        Tambah Sesi Intesif +
                                    </button>
                                    <button class="btn btn-danger px-5 btn-sm ml-2 mb-2" type="button" v-on:click="addPattern">
                                        Tambah Pola +
                                    </button>
                                </div>
                            </div>
                            <div class="pt-3 text-center">
                                <button type="submit" class="btn btn-danger btn-sm px-5 mb-2">
                                    Save
                                </button>
                                <router-link v-bind:to="{ name: 'branch/view', params: {id: branch.id} }" exact class="btn btn-outline-danger btn-sm px-5 ml-3 mb-2">
                                    Cancel
                                </router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Datetimepicker from 'vue-bootstrap-datetimepicker';

    export default {
        name: "BranchProgramAdd",
        components: {
            Multiselect,
            Datetimepicker
        },
        data() {
            return {
                form: {
                    programType: '',
                    gradeID: '',
                    patterns: [],
                    intensiveSchedules: []
                },
                branch: {},
                grades: [],
                types: [],
                days: [],
                datetimepickerOption: {format: 'HH:mm:ss', useCurrent: 'day', locale: 'id', showClear: true}
            };
        },
        methods: {
            addTag(newTag) {
                this.types.push(newTag);
                this.form.programType = newTag;
            },
            addPattern() {
                var total = this.form.patterns.push([]);
                this.addTime(total - 1);
            },
            addIntensive() {
                this.form.intensiveSchedules.push('');
            },
            addTime(patternIndex) {
                var times = this.form.patterns[patternIndex];
                if (typeof times !== typeof undefined) {
                    times.push({
                        day: '',
                        start: '',
                        end: '',
                        slots: ''
                    });
                }
            },
            removePattern(index) {
                this.form.patterns.splice(index, 1);
            },
            removeIntensive(index) {
                this.form.intensiveSchedules.splice(index, 1);
            },
            removeTime(patternIndex, index) {
                var periods = this.form.patterns[patternIndex];
                if (typeof periods !== typeof undefined) {
                    periods.splice(index, 1);
                }
            },
            save() {
                this.axios.post(process.env.API_URL + '/branch-program', Object.assign({}, this.form, {branchID: this.branch.id})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'branch/view', params: {id: this.branch.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            }
        },
        created() {
            this.addPattern();
            this.axios.all([
                this.axios.get(process.env.API_URL + '/program-type'),
                this.axios.get(process.env.API_URL + '/grade'),
                this.axios.get(process.env.API_URL + '/branch/' + this.$route.params.id)
            ]).then(this.axios.spread(function (responseProgram, responseGrade, responseBranch) {
                this.types = responseProgram.data.data.map(function (item) {
                    return item.name;
                });
                this.grades = responseGrade.data.data;
                this.branch = responseBranch.data.data;
                if (!this.branch.isPrimary) {
                    this.$router.replace({name: 'error', params: {code: 403, message: 'Franchise branch can not add program'}});
                }

                document.title = this.branch.name + ' - Add Program - ' + process.env.APP_NAME;
            }.bind(this))).catch((error) => {
                this.$router.replace({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
            });
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/branch/program/Add.vue